import React from "react";
import { Modal } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { DRAWER_TYPES } from "Constantes/drawers";
import { setActiveDrawer } from "../../Slices/uiSlice";
import { Notifications } from "../Notifications/Notifications";
import "./NotificationsModal.scss";

/**
 * Componente modal que contiene las notificaciones de la aplicación.
 * Utiliza Material-UI Modal y se controla mediante Redux para mostrar/ocultar.
 * @returns {JSX.Element} Componente NotificationsModal renderizado
 */
export const NotificationsModal = () => {
  const dispatch = useDispatch();
  const activeDrawer = useSelector((state) => state.ui.activeDrawer);
  const open = activeDrawer === DRAWER_TYPES.NOTIFICATIONS;

  const onClose = () => {
    dispatch(setActiveDrawer(null));
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="notifications-modal"
      className="notifications-modal"
    >
      <div className="notifications-card">
        <Notifications onClose={onClose} />
      </div>
    </Modal>
  );
};
